import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const ClosurePage = () => {
  return (
    <main
      data-testid="closure-page"
      className="min-h-screen w-full flex items-center justify-center px-6 py-16"
      style={{ backgroundColor: "#f3ebde" }}
    >
      <div className="max-w-2xl w-full text-center">
        <div
          data-testid="closure-divider-top"
          className="mx-auto mb-10 h-px w-16"
          style={{ backgroundColor: "#8a7559" }}
        />

        <h1
          data-testid="closure-title"
          className="font-serif tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight mb-8"
          style={{
            fontFamily: '"Playfair Display", Georgia, serif',
            color: "#3d2f20",
          }}
        >
          Encerramos as nossas atividades
        </h1>

        <p
          data-testid="closure-message"
          className="text-base sm:text-lg leading-relaxed"
          style={{
            fontFamily: '"Cormorant Garamond", Georgia, serif',
            color: "#4a3b2a",
          }}
        >
          Para entrar em contato por favor escreva para{" "}
          <span
            data-testid="closure-email"
            className="font-medium whitespace-nowrap"
            style={{ color: "#3d2f20" }}
          >
            mammytogo@gmail.com
          </span>
        </p>

        <div
          data-testid="closure-divider-bottom"
          className="mx-auto mt-12 h-px w-16"
          style={{ backgroundColor: "#8a7559" }}
        />
      </div>
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ClosurePage />} />
          <Route path="/password" element={<ClosurePage />} />
          <Route path="*" element={<ClosurePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
